<form
    [formGroup]="formGroup"
    (ngSubmit)="handleSubmit()"
>
    @if (isBusinessAccount()) {
        <div class="grid-container">
            <div class="form-control g-12 m-24:b">
                <label for="company-input">Schule/Verein/Firma*: </label>
                <input
                    id="company-input"
                    type="text"
                    formControlName="company"
                    placeholder="Schule/Verein/Firma*"
                />
                @if (formGroup.controls.company.touched && formGroup.controls.company.invalid) {
                    @if (formGroup.controls.company.errors.minlength) {
                        <span
                            class="form-error-note"
                            aria-live="polite"
                            >{{ errorMessages.company.minlength }}</span
                        >
                    } @else {
                        <span
                            class="form-error-note"
                            aria-live="polite"
                            >{{ errorMessages.company.default }}</span
                        >
                    }
                }
            </div>
            <app-portal-widget-details
                class="g-12 md:g-6 m-48:b"
                heading="Ansprechperson"
                [detail]="customer().fullName"
            />
        </div>
    } @else {
        <div class="grid-container m-24:b">
            <div class="form-control g-12 xs:g-8 sm:g-6 lg:g-4">
                <label for="anrede-select">Anrede: </label>
                <select
                    id="anrede-select"
                    formControlName="titleId"
                    required
                >
                    @for (title of personTitles(); track title.id) {
                        <option [value]="title.id">{{ title.description }}</option>
                    }
                </select>
                @if (formGroup.controls.titleId.touched && formGroup.controls.titleId.invalid) {
                    <span
                        class="form-error-note"
                        aria-live="polite"
                        >{{ errorMessages.title }}</span
                    >
                }
            </div>
        </div>
        <div class="grid-container">
            <app-portal-widget-details
                class="g-12 sm:g-6 m-24:b"
                heading="Name"
                [detail]="customer().fullName"
            />
            <app-portal-widget-details
                class="g-12 sm:g-6 m-48:b"
                heading="Geburtsdatum"
                [detail]="customer().dateOfBirth"
            />
        </div>
    }
    <div class="grid-container vertical-gutter-lg">
        <div class="form-control g-12">
            <label for="street-input">Straße & Hausnr.*: </label>
            <input
                id="street-input"
                type="text"
                formControlName="street"
                placeholder="Straße & Hausnr.*"
            />
            @if (formGroup.controls.street.touched && formGroup.controls.street.invalid) {
                <span
                    class="form-error-note"
                    aria-live="polite"
                    >{{ errorMessages.street }}</span
                >
            }
        </div>

        <div class="form-control g-12 xs:g-4">
            <label for="zip-input">PLZ*: </label>
            <input
                id="zip-input"
                type="text"
                formControlName="zip"
                placeholder="PLZ*"
            />
            @if (formGroup.controls.zip.touched && formGroup.controls.zip.invalid) {
                <span
                    class="form-error-note"
                    aria-live="polite"
                    >{{ errorMessages.zip }}</span
                >
            }
        </div>

        <div class="form-control g-12 xs:g-8">
            <label for="city-input">Ort*: </label>
            <input
                id="city-input"
                type="text"
                formControlName="city"
                placeholder="Ort*"
            />
            @if (formGroup.controls.city.touched && formGroup.controls.city.invalid) {
                @if (formGroup.controls.city.errors.minlength) {
                    <span
                        class="form-error-note"
                        aria-live="polite"
                        >{{ errorMessages.city.minlength }}</span
                    >
                } @else {
                    <span
                        class="form-error-note"
                        aria-live="polite"
                        >{{ errorMessages.city.default }}</span
                    >
                }
            }
        </div>

        <div class="form-control g-12 xs:g-8 sm:g-6">
            <label for="phone-input">Telefon*: </label>
            <input
                id="phone-input"
                type="text"
                formControlName="phone"
                placeholder="Telefon*"
            />
            @if (formGroup.controls.phone.touched && formGroup.controls.phone.invalid) {
                <span
                    class="form-error-note"
                    aria-live="polite"
                    >{{ errorMessages.phone }}</span
                >
            }
        </div>

        <app-required-info
            [smallMargins]="true"
            class="g-12"
        />

        <app-portal-action-buttons
            class="g-12"
            confirmText="Speichern"
            rejectText="Abbrechen"
            confirmIcon="save"
            [isConfirmDisabled]="formGroup.pristine || formGroup.invalid || updating()"
            (clickReject)="close.emit()"
            [isUsedToSubmitForm]="true"
        />
    </div>
</form>
